import { GetPaymentReviewRecordQuery } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { PaymentReviewRecordCalc } from "./paymentReviewRecordCalc"
import {
  CalculationItem,
  IPaymentReviewRecordCalc,
  ProductType,
  RateType,
} from "./paymentReviewRecordCalc.types"
import dayjs from "dayjs"

export type PaymentReviewRecordCalcRaw = GetPaymentReviewRecordQuery

export const PaymentReviewRecordCalcParser: IParser<
  IPaymentReviewRecordCalc,
  PaymentReviewRecordCalcRaw
> = {
  toDomain: (data: PaymentReviewRecordCalcRaw): IPaymentReviewRecordCalc => {
    try {
      const record = data.payment_review_records_by_pk

      const calculationItems: CalculationItem[] =
        record?.payment_review_calculations[0]?.calculation_items.map(
          (item) => ({
            gspCode: item.gsp_code,
            productType: item.product_type as ProductType,
            rateType: item.rate_type as RateType,
            directDebit: item.direct_debit,
            productCode: item.product_code ?? undefined,
            productRate1:
              item.product_rate_1 === null
                ? undefined
                : Number(item.product_rate_1),
            productRate2:
              item.product_rate_2 === null
                ? undefined
                : Number(item.product_rate_2),
            productStandingRate: item.product_standing_rate ?? undefined,
            itemCost:
              item.item_cost === null ? undefined : Number(item.item_cost),
            itemCostMonthly:
              item.item_cost === null ? undefined : Number(item.item_cost) / 12,
            meterpointEac1: item.meterpoint_eac_1 ?? undefined,
            meterpointEac2: item.meterpoint_eac_2 ?? undefined,
          }),
        ) ?? []

      const calculationData = record?.payment_review_calculations[0]

      if (!record) {
        throw new Error("PaymentReviewRecordCalcParser: toDomain: missing data")
      }

      return new PaymentReviewRecordCalc(
        record.id,
        record.payment_schedule_period_amount,
        dayjs(record.next_payment_date),
        calculationItems,
        calculationData?.account_balance_applied ?? undefined,
        calculationData?.account_balance,
        calculationData?.estimate_annual_cost,
        calculationData?.new_monthly_amount,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
